
import { Component, Vue, Prop } from "vue-property-decorator";
import Jiaoxue from "../components/login/jiaoxue.vue";
import Ceping from "../components/login/ceping.vue";
@Component({
  components: {
    Ceping,
    Jiaoxue
  },
})
export default class Name extends Vue {
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
}
